{
  "_provenance": {
    "ns": "consent",
    "source": "the chrome around consent: SmsDisclosure, AuditedConsentCard, ReconsentPage — gated; consent wording stays English (R3-B10) (#2109 R3 lane L7)"
  },
  "englishNotice": "This consent is in English; the English text is the one you agree to.",
  "gate": {
    "agree": "I agree · continue",
    "notNow": "Not now",
    "recordFailed": "Couldn’t record your consent",
    "recordFailedDescription": "Please try again. If the problem persists, contact support.",
    "recording": "Recording…"
  },
  "outreach": {
    "anticipatorySupport": {
      "description": "A note of support around known stressful dates — scans, surgery, anniversaries.",
      "label": "Support around hard dates"
    },
    "description": "Choose which kinds of proactive outreach you want from us. Every change is recorded.",
    "loadFailed": "Couldn’t load your settings",
    "loadFailedDescription": "Your current notification preferences are unavailable.",
    "outreachSavedDescription": "Your outreach preferences were updated.",
    "polls": {
      "ariaLabel": "Polls notifications",
      "description": "In-app notifications when TRF publishes a new poll for your family.",
      "label": "Polls"
    },
    "pollsSavedDescription": "Your notification preferences were updated.",
    "quietCheckin": {
      "description": "A caring check-in from us if it’s been quiet for a while.",
      "label": "Gentle check-ins"
    },
    "saved": "Saved",
    "title": "Outreach preferences",
    "unknownError": "Unknown error",
    "updateFailed": "Update failed",
    "updateFailedDescription": "Couldn’t update your preferences. Please try again."
  },
  "reconsent": {
    "accept": "I accept the updated terms",
    "decline": "I do not accept — close my account",
    "lede": "Please review and accept the updated documents to continue.",
    "summary": "<strong>{{title}}</strong> was updated — version {{version}}",
    "summaryEffective": "<strong>{{title}}</strong> was updated — version {{version}}, effective {{date}}",
    "title": "Our policies have been updated"
  }
}
